import TenantReservation from '../../components/settings/tenant/reservation/TenantReservationCustomFields'

const Service = () => {
  return (
    <div className="space-y-10">
      <TenantReservation />
    </div>
  )
}

export default Service
